/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';
import Header from 'parts/Header';
import DigitalProductList from 'parts/DigitalProductList';
import Footer from 'parts/Footer';
import Seo from 'parts/Seo';

export class DigitalProductPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Seo
          title="Produk Digital Teknisi CNC - Tutorial & Guide Mesin CNC & Laser"
          description="Download produk digital dari teknisi CNC profesional untuk memaksimalkan performa mesin CNC dan Laser CO2 Anda. Panduan setting power & speed, alignment, troubleshooting, dan berbagai tutorial praktis lainnya."
          keywords="produk digital teknisi cnc, tutorial laser co2, setting power speed laser, laser alignment, panduan cnc pdf, ebook cnc, tutorial cnc, guide teknisi cnc"
          canonicalUrl="https://teknisi.space/produk-digital"
        />
        <Header />
        <DigitalProductList />
        <Footer />
      </>
    );
  }
}
